import { getMetamaskAccessCodeQueryClient } from "@workspace/casino_core/queries/MetamaskAccessCodeQuery.client";

type Args = { site: Site; address: string };

const getAccessCode = async ({ address, site }: Args) => {
  const { data } = await getMetamaskAccessCodeQueryClient({ site, address });
  return data?.userManagement?.metamaskAccessCode?.accessCode;
};

export default getAccessCode;
